export function getCurrentMonthInput(): string {
  const d = new Date()
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  return `${y}-${m}`
}

export function monthInputToMonthStartDate(month: string): string {
  const v = String(month || '').trim()
  if (!/^\d{4}-\d{2}$/.test(v)) throw new Error('Mês inválido (esperado YYYY-MM)')
  return `${v}-01`
}

export function monthStartDateToMonthInput(dateStr: string): string {
  const v = String(dateStr || '').trim()
  if (!/^\d{4}-\d{2}-\d{2}$/.test(v)) throw new Error('Data inválida (esperado YYYY-MM-DD)')
  return v.slice(0, 7)
}

export function formatMonthLabel(monthStartDate: string): string {
  const v = String(monthStartDate || '').trim()
  const m = /^\d{4}-\d{2}/.exec(v)?.[0] || ''
  return m || '-'
}

